/**
 * Sets CSS custom properties for brand colors on the document root
 * @param brandColors - Object containing brand color values
 */
export const setBrandColorVariables = (brandColors: Record<string, string>) => {
  const root = document.documentElement;

  Object.entries(brandColors).forEach(([key, value]) => {
    const cssPropertyName = `--${key.replace(/_/g, '-')}`;
    root.style.setProperty(cssPropertyName, value);
  });
};
